module.exports = __webpack_public_path__ + "img/certif_06.6f325111.jpg";